import { guardHelper } from 'features/user/helpers'
import { GUARD } from './consts'

export const profileCompleteGuard = {
  type: GUARD.PROFILE_COMPLETE,
  condition: user => guardHelper.isProfileCompleteAllowed(user),
  redirectPath: `/profile/complete`,
}
